import axios from "axios";
import Vue from "vue";

export const merchantBrandState = Vue.observable({
  loaded: false,
  name: "",
  logo: "",
  slogan: "",
});

let pending = null;

function applyBrand(data) {
  const row = data && typeof data === "object" ? data : {};
  merchantBrandState.name = typeof row.name === "string" ? row.name.trim() : "";
  merchantBrandState.logo = typeof row.logo === "string" ? row.logo.trim() : "";
  merchantBrandState.slogan = typeof row.slogan === "string" ? row.slogan.trim() : "";
  merchantBrandState.loaded = true;
}

export function loadMerchantBrand(apiuri) {
  if (merchantBrandState.loaded) {
    return Promise.resolve(merchantBrandState);
  }
  if (pending) {
    return pending;
  }
  pending = axios
    .post(apiuri, { action: "publicbrand" })
    .then(function (response) {
      const body = response && response.data ? response.data : {};
      applyBrand(body.status === 200 ? body.data : {});
      return merchantBrandState;
    })
    .catch(function () {
      applyBrand({});
      return merchantBrandState;
    })
    .finally(function () {
      pending = null;
    });
  return pending;
}

export function refreshMerchantBrand(apiuri) {
  merchantBrandState.loaded = false;
  pending = null;
  return loadMerchantBrand(apiuri);
}
